import cx from 'classnames';
import NextLink from 'next/link';

import {Button, Card, RadialProgress, Text} from '#component/base';
import {KitRegisteredPill} from '#component/partial/KitRegisteredPill';
import {sprinkles} from '#style/sprinkles';

import {LifestylePreviewCardProps} from './LifestylePreviewCard.types';

import * as css from './LifestylePreviewCard.css';

export const LifestylePreviewCard = ({
  className,
  hasActiveSubscription = false,
  lifestyleScore = 0,
  registeredDate = '',
  ...otherProps
}: LifestylePreviewCardProps) => (
  <Card className={cx(css.root, className)} {...otherProps}>
    <div className={css.pillContainer}>
      <KitRegisteredPill registeredDate={registeredDate} />

      <Text
        className={sprinkles({display: ['inline', 'none']})}
        color="deepBurgundy"
        variant="heading2">
        Lifestyle Score Preview
      </Text>
    </div>

    <div className={css.copy}>
      <Text
        className={sprinkles({display: ['none', 'inline']})}
        color="deepBurgundy"
        variant="heading2">
        Lifestyle Score Preview
      </Text>

      <Text color="mineShaft">
        {hasActiveSubscription
          ? 'Your full Lifestyle Summary will be available once you receive your latest TallyAge™ results.'
          : 'Join Tally Health™ as a member to receive a full Lifestyle Summary, including recommendations designed to help you lower your TallyAge™.'}
      </Text>

      <NextLink href="/lifestylepreview" passHref>
        <Button as="a" className={sprinkles({mT: [8, 16, 24]})}>
          View preview
        </Button>
      </NextLink>
    </div>

    <RadialProgress className={css.progress} value={lifestyleScore} />
  </Card>
);
